export default __webpack_public_path__ + "5aa18f75c565acab59db053589350e16.svg";